import React from 'react';
import { TrendingUpIcon, DollarSignIcon, TargetIcon, BuildingIcon, HeartPulseIcon, ShoppingBagIcon, UsersIcon } from 'lucide-react';
export function Impact() {
  const metrics = [{
    icon: TrendingUpIcon,
    stat: '2–3x',
    label: 'Higher Adherence',
    description: 'To prescribed nutrition plans',
    color: 'text-green-600'
  }, {
    icon: DollarSignIcon,
    stat: '40%',
    label: 'Reduced Spend',
    description: 'On low-nutrition foods',
    color: 'text-blue-600'
  }, {
    icon: TargetIcon,
    stat: '85%',
    label: 'Outcome Improvement',
    description: 'Enhanced payer ROI',
    color: 'text-orange-600'
  }];
  const partners = [{
    icon: BuildingIcon,
    title: 'Food-as-Medicine technology providers'
  }, {
    icon: HeartPulseIcon,
    title: 'Health insurers and payers'
  }, {
    icon: ShoppingBagIcon,
    title: 'Retail grocers and meal delivery networks'
  }, {
    icon: UsersIcon,
    title: 'Nutrition benefit managers'
  }];
  return <section className="py-20 bg-gradient-to-b from-green-50 to-white" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        {/* Why It Matters */}
        <div className="text-center mb-16" data-id="element-86">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-87">
            Why It Matters
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-12" data-id="element-88">
            Platforms using Lola see:
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-89">
          {metrics.map((metric, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1" data-id="element-90">
              <metric.icon className={`w-12 h-12 ${metric.color} mb-4`} data-id="element-91" />
              <div className={`text-5xl font-bold ${metric.color} mb-2`} data-id="element-92">
                {metric.stat}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-93">
                {metric.label}
              </h3>
              <p className="text-gray-600" data-id="element-94">{metric.description}</p>
            </div>)}
        </div>

        {/* Who We Partner With */}
        <div className="text-center mb-12" data-id="element-95">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-96">
            Who We Partner With
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-97">
          {partners.map((partner, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-green-100" data-id="element-98">
              <partner.icon className="w-10 h-10 text-green-600 mb-4 mx-auto" data-id="element-99" />
              <p className="text-center font-semibold text-gray-900" data-id="element-100">
                {partner.title}
              </p>
            </div>)}
        </div>

        {/* Final CTA */}
        <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-3xl p-10 text-white text-center shadow-2xl" data-id="element-101">
          <h3 className="text-3xl font-bold mb-4" data-id="element-102">
            Bring Real-World Nutrition Into Your Platform
          </h3>
          <p className="text-xl mb-6 text-green-50 max-w-3xl mx-auto" data-id="element-103">
            Let's make food-as-medicine work in the grocery aisle — not just on
            paper.
          </p>
          <button className="bg-white text-green-600 px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all" data-id="element-104">
            Book a Partner Demo
          </button>
        </div>
      </div>
    </section>;
}